module.exports = __webpack_public_path__ + "static/media/Product1.e4ba9a46.jpeg";